import { Stepper } from 'src/app/shared/components/stepper';

import { usePageHeading } from './hooks/usePageHeading';

export function PageHeading() {
	const {
		data: { pageTitle, hideStepperProgress },
	} = usePageHeading();

	return <Stepper stepperText={pageTitle} currentStep={3} textOnly={hideStepperProgress} mb={24} />;
}
